import React from "react";
import { useQuery, gql } from "@apollo/client";
import { Card, Layout, Spin, Alert } from "antd";
import "./ticketingSystem.css";
import { Navigate, useNavigate } from "react-router-dom";
import CustomerPortalIcon from "../../Images/customerSupportIcon.png";
import { GET_OS_TICKETING_DASHBOARD_VALUES } from "../../services/userAPI";

const { Content } = Layout;

// Function to get first and last date of the current month
const getCurrentMonthDates = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = now.getMonth();

    const firstDay = new Date(year, month, 1);
    const lastDay = new Date(year, month + 1, 0);

    // Formatting date as YYYY-MM-DD
    const formatDate = (date) => {
        const yyyy = date.getFullYear();
        const mm = String(date.getMonth() + 1).padStart(2, "0");
        const dd = String(date.getDate()).padStart(2, "0");
        return `${yyyy}-${mm}-${dd}`;
    };

    return {
        startDate: formatDate(firstDay),
        endDate: formatDate(lastDay),
    };
};

const TicketingSystem = () => {
    const { startDate, endDate } = getCurrentMonthDates();
    const navigate = useNavigate();
    // Execute the GraphQL query
    const { loading, error, data } = useQuery(GET_OS_TICKETING_DASHBOARD_VALUES, {
        variables: { startDate, endDate },
    });

    if (loading)
        return (
            <div className="loading-container">
                <div className="spinner"></div>
            </div>
        );

    if (error)
        return <Alert message="Error" description={error.message} type="error" showIcon />;

    // Extract data from API response
    const dashboardData = data?.getOsTicketingDashboardValues?.[0] ?? {}; // Get first item or empty object

    const assignedTickets = dashboardData?.assignedTickets ?? "";
    const closedTickets = dashboardData?.closedTickets ?? "";
    const openTickets = dashboardData?.openTickets ?? "";
    const overdueTickets = dashboardData?.overdueTickets ?? "";
    const reOpenedTickets = dashboardData?.reOpenedTickets ?? "";
    const deletedTickets = dashboardData?.deletedTickets ?? "";

    const serviceTimeInHours = Number(dashboardData?.serviceTimeInMinutes ?? 0) / 60;
    const responseTimeInHours = Number(dashboardData?.responceTimeInMinutes ?? 0) / 60;


    const reportData = [
        { label: "Total Tickets", value: assignedTickets },
        { label: "Tickets Assigned", value: assignedTickets },
        { label: "Over Due", value: overdueTickets },
        { label: "Closed", value: closedTickets },
        { label: "Re-Opened", value: reOpenedTickets },
        { label: "Deleted", value: deletedTickets },
        { label: "Service Time", value: serviceTimeInHours },
        { label: "Response Time", value: responseTimeInHours },
    ];

    // Function to insert <br/> after the first word
    const formatLabel = (text) => {
        const words = text.split(" ");
        if (words.length > 1) {
            // return (
            //     <>
            //         {words[0]} <br /> {words.slice(1).join(" ")}
            //     </>
            // );
        }
        return text;
    };

    return (
        <Content>
            <div className="ticketing-system">
                {/* Header */}
                <div className="ticketing-header">
                    <div className="ticketing-title">OS Ticketing Reports</div>
                    {/* <button className="customerPortal" onClick={() => window.open("http://helpdesk.quantapeople.com/scp/login.php", "_blank")}>
                        Customer Support
                        {/* <img src={CustomerPortalIcon} alt="Customer Portal" className="customerPortalIcon" /> */}
                    {/* </button>  */}
                </div>
                {/* Cards Container */}
                <div className="ticketing-cards-container">
                    <div className="ticket-card-container">
                        <div className="section-title">This Month</div>
                        <div className="cards-grid">
                            <div className="ticket-card">
                                <div className="card-content">
                                    <span className="card-label">Tickets <br /> Raised</span>
                                    <span className="card-value">{assignedTickets}</span>
                                </div>
                            </div>

                            <div className="ticket-card">
                                <div className="card-content">
                                    <span className="card-label">Tickets <br /> Pending</span>
                                    <span className="card-value">{openTickets}</span>
                                </div>
                            </div>

                            <div className="ticket-card">
                                <div className="card-content">
                                    <span className="card-label">Tickets <br /> Closed</span>
                                    <span className="card-value">{closedTickets}</span>
                                </div>
                            </div>

                            <div className="ticket-card">
                                <div className="card-content">
                                    <span className="card-label">Average <br /> Conversion Time</span>
                                    <span className="card-value">{serviceTimeInHours.toFixed(2)} hr</span>
                                </div>
                            </div>

                            <div className="ticket-card">
                                <div className="card-content">
                                    <span className="card-label">Tickets <br /> Reopened</span>
                                    <span className="card-value">{reOpenedTickets}</span>
                                </div>
                            </div>
                        </div>

                    </div>

                    {/* <div className="ticketing-reports">Reports</div> */}
                    <div className="reports-container">
                        <div className="reports-cards-grid">
                            {reportData.map((item, index) => (
                                <Card className="reports-ticket-card" key={index}>
                                    <div className="reports-card-content">
                                        <span className="reports-card-label">{formatLabel(item.label)}</span>
                                        {item.label === "Total Tickets" && (
                                            <span className="reports-card-subtext"><span style={{ display: "block", visibility: "hidden" }}>(in hr)</span></span>
                                        )}
                                        {item.label === "Tickets Assigned" && (
                                            <span className="reports-card-subtext"><span style={{ display: "block", visibility: "hidden" }}>(in hr)</span></span>
                                        )}
                                        {item.label === "Over Due" && (
                                            <span className="reports-card-subtext"><span style={{ display: "block", visibility: "hidden" }}>(in hr)</span></span>
                                        )}
                                        {item.label === "Closed" && (
                                            <span className="reports-card-subtext"><span style={{ display: "block", visibility: "hidden" }}>(in hr)</span></span>
                                        )}
                                        {item.label === "Re-Opened" && (
                                            <span className="reports-card-subtext"><span style={{ display: "block", visibility: "hidden" }}>(in hr)</span></span>
                                        )}
                                        {item.label === "Deleted" && (
                                            <span className="reports-card-subtext"><span style={{ display: "block", visibility: "hidden" }}>(in hr)</span></span>
                                        )}
                                        {item.label === "Response Time" && (
                                            <span className="reports-card-subtext"><span style={{ display: "block", visibility: "hidden" }}>(in hr)</span></span>
                                        )}
                                        {item.label === "Service Time" && (
                                            <span className="reports-card-subtext"><span style={{ display: "block", visibility: "hidden" }}>(in hr)</span></span>
                                        )}
                                        <span className="reports-card-value">{item.value}</span>

                                    </div>
                                </Card>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </Content>
    );
};

export default TicketingSystem;
